<div class="action-wrapper" (click)="$event.stopPropagation()">
  <!-- Added by Amisha on 2026-06-19. Reason: render the renewals action menu in a
       body-level popover so the custom Figma-style card is not clipped by the table container. -->
  <button
    type="button"
    class="action-trigger"
    [ngbPopover]="actionMenu"
    #actionPopover="ngbPopover"
    triggers="manual"
    [autoClose]="'outside'"
    container="body"
    placement="bottom-end top-end"
    popoverClass="renewals-action-popover"
    (click)="togglePopover(actionPopover, $event)"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
  >
    Action
  </button>

  <ng-template #actionMenu>
    <!-- Added by Amisha on 2026-06-19. Reason: keep the renewals action list in a
         custom card layout so sizing, hover state, and scrolling match the Janus design. -->
    <div class="renewals-action-menu-card">
    <button
      type="button"
      class="renewals-action-item"
      (click)="onViewDetails()"
    >
      <span class="renewals-action-item-label">View Details</span>
    </button>
    <button
      type="button"
      class="renewals-action-item"
      (click)="onViewApplication()"
    >
      <span class="renewals-action-item-label">View Application</span>
    </button>
    <button
      type="button"
      class="renewals-action-item"
      (click)="onRenew()"
      [disabled]="canRenew && !canRenew(row)"
    >
      <span class="renewals-action-item-label">Renew</span>
    </button>
    <button
      type="button"
      class="renewals-action-item"
      (click)="onDelete()"
      [disabled]="canDelete && !canDelete(row)"
    >
      <span class="renewals-action-item-label">Delete</span>
    </button>
    <button
      type="button"
      class="renewals-action-item"
      (click)="onDisable()"
      [disabled]="canDisable && !canDisable(row)"
    >
      <span class="renewals-action-item-label">Disable</span>
    </button>
    <button
      type="button"
      class="renewals-action-item"
      (click)="onEnable()"
      [disabled]="canEnable && !canEnable(row)"
    >
      <span class="renewals-action-item-label">Enable</span>
    </button>
    </div>
  </ng-template>
</div>
